module.exports = __webpack_public_path__ + "img/video.f3e2531c.svg";